(function () {
  'use strict';

  // This is used for booking item and booking item service item

  angular
    .module('app')
    .service('BookingItemNotificationModalService', BookingItemNotificationModalService);

  BookingItemNotificationModalService.$inject = ['ModalService'];

  function BookingItemNotificationModalService(ModalService) {
    let preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    let service = {
      openUpdateBookingItemNotification: openUpdateBookingItemNotification,
      openSendBookingItemNotificationToProvider: openSendBookingItemNotificationToProvider,
      openSendNotificationToPreviousProvider: openSendNotificationToPreviousProvider,
    };

    return service;

    ////////////////////////

    // --------------------------- openUpdateBookingItemNotification -------------------------

    function openUpdateBookingItemNotification(
      booking,
      bookingItem,
      bookingItemServiceItem,
      notification,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/booking-item-notification/modals/update-booking-item-notification-modal.html',
        controller: OpenUpdateBookingItemNotificationCtrl,
        controllerAs: 'vm',
        inputs: {
          notification: notification,
          bookingItem: bookingItem,
          bookingItemServiceItem: bookingItemServiceItem,
          booking: booking,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      OpenUpdateBookingItemNotificationCtrl.$inject = [
        '$element',
        '$translate',
        'notification',
        'booking',
        'bookingItem',
        'bookingItemServiceItem',
        'successCallback',
      ];
    }

    function OpenUpdateBookingItemNotificationCtrl(
      $element,
      $translate,
      notification,
      booking,
      bookingItem,
      bookingItemServiceItem,
      successCallback
    ) {
      let vm = this;

      vm.notification = notification;
      vm.bookingItem = bookingItem;
      vm.bookingItemServiceItem = bookingItemServiceItem;

      // console.log(notification);

      vm.bookingCurrency = booking.currency;

      vm.companyId = booking.company_id;

      // vm.modalTitle = 'SET_STATUS_FOR_BOOKING_ITEM';
      // vm.modalTitle = $translate('SET_STATUS'); // needs $filter('translate'); as it render $promise without it
      vm.modalTitle = $translate.instant('SET_SERVICE_STATUS');

      vm.status = !bookingItemServiceItem ? bookingItem.status : bookingItemServiceItem.status;

      vm.canPending = false;
      vm.canConfirm = false;
      vm.canDecline = false;
      vm.canCancel = false;

      // Methods
      vm.changeNotificationStatusTo = changeNotificationStatusTo;
      vm.onBookingItemNotificationPending = onBookingItemNotificationPending;
      vm.onBookingItemNotificationConfirmed = onBookingItemNotificationConfirmed;
      vm.onBookingItemNotificationDeclined = onBookingItemNotificationDeclined;

      // Initializers
      setNotificationOptions();
      changeNotificationStatusTo('');

      // For booking item only
      if (!bookingItemServiceItem && bookingItem.based_on_service_items) {
        checkBookingItemServiceItemStatus();
      }

      function setNotificationOptions() {
        if (vm.status === 'confirmed') {
          vm.canPending = true;
          vm.canDecline = true;
          vm.canCancel = true;
        } else if (vm.status === 'cancelled') {
          vm.canPending = true;
        } else if (vm.status === 'declined') {
          if (booking.status === 'cancelled') {
            vm.canPending = true;
            vm.canCancel = true;
          } else {
            vm.canPending = true;
            vm.canConfirm = true;
            vm.canCancel = true;
          }
        } else if (vm.status === 'pending' || vm.status === 'requested') {
          if (booking.status === 'cancelled') {
            vm.canDecline = true;
            vm.canCancel = true;
          } else {
            vm.canConfirm = true;
            vm.canDecline = true;
            vm.canCancel = true;
          }
        }
      }
      function changeNotificationStatusTo(option) {
        vm.option = option || null;

        let modalMode;

        switch (option) {
          case 'pending':
            modalMode = 'primary';
            break;
          case 'confirm':
            modalMode = 'success';
            break;
          case 'decline':
            modalMode = 'warning';
            break;
          case 'cancel':
            modalMode = 'danger';
            break;
          default:
            modalMode = 'default';
            break;
        }

        vm.modalMode = modalMode;
      }

      function checkBookingItemServiceItemStatus() {
        vm.bookingItemServiceItemsStatusCompleted = true;

        for (let i = vm.bookingItem.booking_item_service_items.length - 1; i >= 0; i--) {
          if (
            vm.bookingItem.booking_item_service_items[i].status === 'pending' ||
            vm.bookingItem.booking_item_service_items[i].status === 'requested'
          ) {
            vm.bookingItemServiceItemsStatusCompleted = false;
            break;
          }
        }
      }

      function onBookingItemNotificationPending(bookingItemObj) {
        $element.modal('hide');
        successCallback(bookingItemObj);
      }

      function onBookingItemNotificationConfirmed(bookingItemObj) {
        $element.modal('hide');
        successCallback(bookingItemObj);
      }

      function onBookingItemNotificationDeclined(bookingItemObj) {
        $element.modal('hide');
        successCallback(bookingItemObj);
      }
    }

    // --------------------------- openSendBookingItemNotificationToProvider -------------------------

    function openSendBookingItemNotificationToProvider(
      companyId,
      bookingItem,
      bookingItemServiceItem,
      notification,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/booking-item-notification/modals/booking-item-notification-to-provider-modal.html',
        controller: OpenBookingItemNotificationToProviderCtrl,
        controllerAs: 'vm',
        inputs: {
          notification: notification,
          bookingItem: bookingItem,
          bookingItemServiceItem: bookingItemServiceItem,
          companyId: companyId,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      OpenBookingItemNotificationToProviderCtrl.$inject = [
        '$element',
        'notification',
        'bookingItem',
        'bookingItemServiceItem',
        'companyId',
        'successCallback',
        'BookingItemNotificationService',
      ];
    }

    function OpenBookingItemNotificationToProviderCtrl(
      $element,
      notification,
      bookingItem,
      bookingItemServiceItem,
      companyId,
      successCallback,
      BookingItemNotificationService
    ) {
      let vm = this;

      vm.modalTitle = 'SEND_REQUEST_TO_PROVIDER';

      vm.notification = notification || {};

      // console.log(notification);

      let bookingItemServiceItemId = bookingItemServiceItem ? bookingItemServiceItem.id : null;

      vm.bookingItemData = !bookingItemServiceItem ? bookingItem : bookingItemServiceItem;

      vm.sendNotificationToProvider = function (isFormValid) {
        vm.formErrors = false;

        if (!isFormValid) {
          vm.formErrors = true;

          return;
        }

        let params = {
          email: vm.bookingItemData.provider.email,
          company_id: companyId,
        };

        if (!vm.notification.id) {
          createAndSendNotificationRequest(params);
        } else {
          reSendNotificationRquest(params);
        }
      };

      function createAndSendNotificationRequest(params) {
        vm.notification.payment_net_cost = vm.bookingItemData.total_cost;
        vm.notification.status = 'requested';

        params.send_notification_to_provider = true;

        // let file = { file: vm.myFile }; // why ?
        let file = {};

        vm.sendingForm = true;

        BookingItemNotificationService.saveBookingItemNotification(
          bookingItem.booking_id,
          bookingItem.id,
          bookingItemServiceItemId,
          vm.notification,
          params,
          file
        ).then(function (response) {
          response = response.data;

          if (!response.errors) {
            let data = {
              notification: response.notification,
              booking_item_status: response.booking_item_status,
              booking_status: response.booking_status,
              booking_item_service_item_status: null,
            };

            if (bookingItemServiceItem) {
              data.booking_item_service_item_status = response.booking_item_service_item_status;
            }

            vm.sendingForm = false;

            $element.modal('hide');
            successCallback(data);
          }
        });
      }

      // Re-send notification request
      function reSendNotificationRquest(params) {
        vm.sendingForm = true;

        setTimeout(function () {
          // Delay x sec
          BookingItemNotificationService.reSendBookingItemNotificationToProvider(
            bookingItem.booking_id,
            bookingItem.id,
            bookingItemServiceItemId,
            vm.notification.id,
            params
          ).then(function (response) {
            if (response) {
              $element.modal('hide');
              // successCallback(data); // Not needed as we do not to update the objet

              vm.sendingForm = false;
            }
          });
        }, 500);
      }
    }

    // --------------------------- openSendNotificationToPreviousProvider -------------------------

    function openSendNotificationToPreviousProvider(
      companyId,
      bookingItem,
      bookingItemServiceItem,
      newProvider,
      confirm_callback,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/booking-item-notification/modals/booking-item-change-provider-notification-modal.html',
        controller: openSendNotificationToPreviousProviderCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItem: bookingItem,
          notification: {},
          bookingItemServiceItem: bookingItemServiceItem,
          newProvider: newProvider,
          confirm_callback: confirm_callback,
          companyId: companyId,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      openSendNotificationToPreviousProviderCtrl.$inject = [
        '$element',
        'bookingItem',
        'bookingItemServiceItem',
        'newProvider',
        'confirm_callback',
        'notification',
        'companyId',
        'successCallback',
        'BookingItemNotificationService',
      ];
    }

    function openSendNotificationToPreviousProviderCtrl(
      $element,
      bookingItem,
      bookingItemServiceItem,
      newProvider,
      confirm_callback,
      notification,
      companyId,
      successCallback,
      BookingItemNotificationService
    ) {
      let vm = this;

      vm.modalTitle = 'CHANGE_PROVIDER';

      vm.sendRequestToNewProvider = true;
      vm.sendEmailToOldProvider = true;

      vm.notification = notification;

      let bookingItemServiceItemId = bookingItemServiceItem ? bookingItemServiceItem.id : null;

      vm.bookingItemData = !bookingItemServiceItem ? bookingItem : bookingItemServiceItem;
      vm.newProviderData = newProvider;

      vm.sendNotificationToProvider = function (isFormValid) {
        vm.formErrors = false;

        if (!isFormValid) {
          vm.formErrors = true;

          return;
        }

        if (vm.sendRequestToNewProvider) {
          let params = {
            email: vm.newProviderData.provider.email,
            company_id: companyId,
          };

          createAndSendNotificationRequest(params);
        } else {
          confirm_callback(vm.sendEmailToOldProvider);

          $element.modal('hide');
        }
      };

      function createAndSendNotificationRequest(params) {
        vm.notification.payment_net_cost = vm.bookingItemData.total_cost;
        vm.notification.status = 'requested';

        params.send_notification_to_provider = vm.sendRequestToNewProvider ? true : false;

        // let file = { file: vm.myFile }; // why ?
        let file = {};

        vm.sendingForm = true;

        BookingItemNotificationService.saveBookingItemNotification(
          bookingItem.booking_id,
          bookingItem.id,
          bookingItemServiceItemId,
          vm.notification,
          params,
          file
        ).then(function (response) {
          response = response.data;

          if (!response.errors) {
            let data = {
              notification: response.notification,
              booking_item_status: response.booking_item_status,
              booking_status: response.booking_status,
              booking_item_service_item_status: null,
            };

            if (bookingItemServiceItem) {
              data.booking_item_service_item_status = response.booking_item_service_item_status;
            }

            vm.sendingForm = true;

            confirm_callback(vm.sendEmailToOldProvider);

            $element.modal('hide');
            successCallback(data);
          }
        });
      }
    }
  }
})();
